import { Component, Input, ViewEncapsulation } from "@angular/core";
import { MatMenuModule } from "@angular/material/menu";
import { MatIconModule } from "@angular/material/icon";

export interface CerrixKebabMenuItem {
    icon: string;
    text: string;
    onClick: () => void;
}

@Component({
    selector: "app-cerrix-kebab-menu",
    templateUrl: "./cerrix-kebab-menu.component.html",
    styleUrl: "./cerrix-kebab-menu.component.scss",
    standalone: true,
    imports: [
        MatMenuModule,
        MatIconModule,
    ],
    encapsulation: ViewEncapsulation.None
})
export class CerrixKebabMenuComponent {
    @Input() menuItems: CerrixKebabMenuItem[];
}
